export default defineNuxtRouteMiddleware(to => {
  const authStore = useAuthStore();

  if (authStore.profile) {
    // Giriş yapmış kullanıcılar için login ve register sayfalarına erişimi engelle
    if (to.name?.toString().includes('login') || to.name?.toString().includes('register')) {
      const router = useRouter();
      const localePath = useLocalePath();
      router.push(localePath('/'));
      return;
    }
    return;
  } else {
    // Giriş yapmamış kullanıcılar için chat sayfalarına erişimi engelle
    // Allow access to shared chat pages
    if (to.name?.toString().includes('chat') && !to.path.includes('/chat/share/')) {
      // Dialog'u göster
      authStore.setShowNeedLogin(true);
      
      // Kullanıcıyı yönlendirme, bulunduğu sayfada kalsın
      return abortNavigation();
    }
    return;
  }
});
